/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const clinicDetailBookings30dMin = 0
export const clinicDetailBookings30dMax = 9007199254740991

export const clinicDetailBookings7dMin = 0
export const clinicDetailBookings7dMax = 9007199254740991

export const clinicDetailCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicDetailDeactivatedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicDetailErrors24hMin = 0
export const clinicDetailErrors24hMax = 9007199254740991

export const clinicDetailErrors7dMin = 0
export const clinicDetailErrors7dMax = 9007199254740991

export const clinicDetailIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicDetailLastSyncedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicDetailPfLastHeartbeatAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicDetailSecurityCodeStatusLastCodeAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicDetailUsersCountMin = 0
export const clinicDetailUsersCountMax = 9007199254740991

export const ClinicDetail = zod.object({
  bookings30d: zod.int().min(clinicDetailBookings30dMin).max(clinicDetailBookings30dMax),
  bookings7d: zod.int().min(clinicDetailBookings7dMin).max(clinicDetailBookings7dMax),
  branding: zod.object({
    accentColor: zod.string().nullable(),
    logoUrl: zod.string().nullable(),
  }),
  connection: zod.enum(['connected', 'not_connected']),
  createdAt: zod.iso.datetime({ offset: true }).regex(clinicDetailCreatedAtRegExp),
  deactivatedAt: zod.union([zod.iso.datetime({ offset: true }).regex(clinicDetailDeactivatedAtOneRegExp), zod.null()]),
  displayStatus: zod.enum(['active', 'inactive', 'not_connected']),
  errors24h: zod.int().min(clinicDetailErrors24hMin).max(clinicDetailErrors24hMax),
  errors7d: zod.int().min(clinicDetailErrors7dMin).max(clinicDetailErrors7dMax),
  id: zod.uuid().regex(clinicDetailIdRegExp),
  lastSyncedAt: zod.union([zod.iso.datetime({ offset: true }).regex(clinicDetailLastSyncedAtOneRegExp), zod.null()]),
  name: zod.string(),
  needsAttention: zod.boolean(),
  pf: zod.object({
    degradedReason: zod.string().nullable(),
    lastHeartbeatAt: zod.union([
      zod.iso.datetime({ offset: true }).regex(clinicDetailPfLastHeartbeatAtOneRegExp),
      zod.null(),
    ]),
    pfKeeperApp: zod.enum(['up', 'degraded', 'down', 'unknown']),
    pfSession: zod.enum(['up', 'degraded', 'down', 'unknown']),
    status: zod.enum(['healthy', 'degraded', 'down', 'unknown', 'not_connected', 'inactive']),
  }),
  pfMessagesEnabled: zod.boolean(),
  securityCodeAuto: zod.boolean(),
  securityCodePhone: zod.string().nullable(),
  securityCodeStatus: zod.object({
    lastCodeAt: zod.union([
      zod.iso.datetime({ offset: true }).regex(clinicDetailSecurityCodeStatusLastCodeAtOneRegExp),
      zod.null(),
    ]),
    lastResult: zod.union([
      zod.enum(['logged_in', 'rejected', 'expired', 'not_awaiting', 'failed', 'timeout']),
      zod.null(),
    ]),
  }),
  setup: zod.object({
    connected: zod.boolean(),
    firstAdminSetPassword: zod.boolean(),
    hasBookableVisitType: zod.boolean(),
  }),
  slug: zod.string(),
  status: zod.enum(['active', 'inactive']),
  testingIgnorePfHours: zod.boolean(),
  timeZone: zod.string(),
  usersCount: zod.int().min(clinicDetailUsersCountMin).max(clinicDetailUsersCountMax),
})

export type ClinicDetail = zod.input<typeof ClinicDetail>
export type ClinicDetailOutput = zod.output<typeof ClinicDetail>
